import { render, staticRenderFns } from "./LocaleSwitcherModal.vue?vue&type=template&id=23270954&scoped=true&"
import script from "./LocaleSwitcherModal.vue?vue&type=script&lang=ts&"
export * from "./LocaleSwitcherModal.vue?vue&type=script&lang=ts&"
import style0 from "./LocaleSwitcherModal.vue?vue&type=style&index=0&id=23270954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23270954",
  null
  
)

export default component.exports